/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */

export enum TSKantonCode {
    ZH = <any> 'ZH',
    BE = <any> 'BE',
    LU = <any> 'LU',
    UR = <any> 'UR',
    SZ = <any> 'SZ',
    OW = <any> 'OW',
    NW = <any> 'NW',
    GL = <any> 'GL',
    ZG = <any> 'ZG',
    FR = <any> 'FR',
    SO = <any> 'SO',
    BS = <any> 'BS',
    BL = <any> 'BL',
    SH = <any> 'SH',
    AR = <any> 'AR',
    AI = <any> 'AI',
    SG = <any> 'SG',
    GR = <any> 'GR',
    AG = <any> 'AG',
    TG = <any> 'TG',
    TI = <any> 'TI',
    VD = <any> 'VD',
    VS = <any> 'VS',
    NE = <any> 'NE',
    GE = <any> 'GE',
    JU = <any> 'JU',
    UNBEKANNT = <any> 'UNBEKANNT'

}

export function getKantonCodeList(): Array<TSKantonCode> {
    return [
        TSKantonCode.ZH,
        TSKantonCode.BE,
        TSKantonCode.LU,
        TSKantonCode.UR,
        TSKantonCode.SZ,
        TSKantonCode.OW,
        TSKantonCode.NW,
        TSKantonCode.GL,
        TSKantonCode.ZG,
        TSKantonCode.FR,
        TSKantonCode.SO,
        TSKantonCode.BS,
        TSKantonCode.BL,
        TSKantonCode.SH,
        TSKantonCode.AR,
        TSKantonCode.AI,
        TSKantonCode.SG,
        TSKantonCode.GR,
        TSKantonCode.AG,
        TSKantonCode.TG,
        TSKantonCode.TI,
        TSKantonCode.VD,
        TSKantonCode.VS,
        TSKantonCode.NE,
        TSKantonCode.GE,
        TSKantonCode.JU,
    ];
}



// WEBPACK FOOTER //
// ./src/app/models/enums/TSKantonCode.ts